import { UnavailableItemsDialogProps } from './interface'

export function UnavailableItemsDialog({ items }: UnavailableItemsDialogProps) {
  return (
    <div className='w-[560px] max-w-full'>
      <p className='font-mitr text-center text-[24px] text-secondary font-medium'>
        อนุมัติแคมเปญไม่ได้
      </p>
      <div className='text-center mt-[12px] text-[14px] font-light text-secondary'>
        <p>
          มี {items.length} รายการที่ไม่มีตอนให้ลดราคา
          ตอนที่ลดได้ต้องเผยแพร่แล้วและราคาสูงกว่าราคาที่ลด
        </p>
        <p>
          กรุณาปฏิเสธแคมเปญนี้
          แล้วแก้ช่วงตอนหรือราคาของรายการด้านล่างก่อนส่งตรวจใหม่
        </p>
      </div>
      <div className='mt-[20px] max-h-[320px] overflow-y-auto border rounded-[8px]'>
        <table className='w-full text-[14px] text-secondary'>
          <thead className='sticky top-0 bg-white text-[12px] text-blue-3'>
            <tr>
              <th className='px-[12px] py-[8px] font-normal text-left'>
                Book ID
              </th>
              <th className='px-[12px] py-[8px] font-normal text-left'>
                ชื่อหนังสือ
              </th>
              <th className='px-[12px] py-[8px] font-normal text-right'>
                ช่วงตอน
              </th>
              <th className='px-[12px] py-[8px] font-normal text-right'>
                ลดเหลือตอนละ
              </th>
            </tr>
          </thead>
          <tbody>
            {items.map(item => (
              <tr
                key={`${item.bookId}-${item.chapterIdStart}`}
                className='border-t'
              >
                <td className='px-[12px] py-[8px]'>{item.bookId}</td>
                <td className='px-[12px] py-[8px]'>{item.bookTitle}</td>
                <td className='px-[12px] py-[8px] text-right whitespace-nowrap'>
                  {item.chapterIdStart}-{item.chapterIdEnd}
                </td>
                <td className='px-[12px] py-[8px] text-right'>
                  {item.discountPricePerChapter}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  )
}
